import React from "react";

import styles from "./project.module.css";
import projectCoverImg from "../asset/project-cover10.png";
import ProjectsData from "../../Data/ProjectsData";

import ProgrammingSkills from "../Professional Skillset/ProgrammingSkills";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

const Projects = (props) => {
    const nonThemeColor = useSelector(state => state.nonThemeColor);
    const uiColor = useSelector(state => state.uiColor);
    let projects = ProjectsData.DUMMY_PROJECTS;
    return (
        <React.Fragment>
            <div className={styles.projects}>
                <section className={styles.projectImg}>
                    <img src={projectCoverImg} alt="" />
                </section>
                <section className={styles.projectHeader}>
                    <h1><span style={{ color: nonThemeColor }}>A Image Of Our </span><span style={{ color: uiColor }}>Works</span></h1>
                    <div>Our Works Programming Skills</div>
                    <div>https://github.com/FirebrowserDevs/FireBrowser-Uwp/blob/main/LICENSE</div>
                </section>              
 ``           </div>
            <ProgrammingSkills />
            
          
        </React.Fragment>
    )
};

export default Projects;